const styles = theme => ({
  headerTitle: {
    fontSize: "1.5rem",
    fontWeight: 600,
  },  
  container: {
    backgroundColor: '#fff'  
  },
  formControl: {
    display: 'block',
  },
  select: {
    minWidth: 200,
  },
  dialog: {
    minWidth: 500,
  },
  close: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
  },
  dialogContainer: {
    padding: theme.spacing(2, 3),
  },
  table: {
    border: '1px solid #eaeaea',
    maxHeight: '60vh',
  },
  wrapper: {
    border: '1px solid #eaeaea',
  },
  notice: {
    color: 'red',
    fontSize: 13,
    fontStyle: 'italic',
  },
  error: {
    color: 'red',
    textAlign: 'center',
  },
  link: {
    fontSize: 12,
    color: '#2196f3',
    textDecoration: 'underline',
    cursor: 'pointer',
  },
  loadingOverlay: {
    position: "absolute",
    top: 0, left: 0, bottom: 0, right: 0,
    backgroundColor: 'rgba(200, 200, 200, 0.5)',
    zIndex: 99,
  },
  loading: {
    display: "flex",
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',
  },  
});

export default styles;